// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-detail {
  display: none;
  animation: fadeIn var(--transition-slow) ease-out;
}

.account-detail.active {
  display: block;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.detail-header {
  background: var(--surface-card);
  padding: var(--spacing-xl);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
  margin-bottom: var(--spacing-xl);
  border: 1px solid var(--surface-border);
  position: relative;
  overflow: hidden;
}

.detail-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--color-primary), var(--color-primary-light));
}

.detail-header h2 {
  font-size: var(--font-size-3xl);
  color: var(--text-primary);
  margin-bottom: var(--spacing-sm);
  font-weight: 700;
  letter-spacing: -0.02em;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 3rem;
}

.account-info {
  flex: 0 0 auto;
}

.contract-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  background: var(--color-bg-secondary);
  padding: var(--spacing-lg);
  border-radius: var(--radius-lg);
  border: 1px solid var(--surface-border);
  position: relative;
}

.contract-info::before {
  content: 'CONTRACT DETAILS';
  position: absolute;
  top: -10px;
  left: var(--spacing-lg);
  background: var(--surface-card);
  padding: 0 var(--spacing-sm);
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  font-weight: 600;
  letter-spacing: 0.08em;
}

.contract-row {
  display: flex;
  gap: 2rem;
}

.contract-item {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.contract-label {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
  margin-bottom: var(--spacing-xs);
}

.contract-value {
  font-size: var(--font-size-base);
  color: var(--color-secondary);
  font-weight: 600;
}

.contract-value.highlight {
  color: var(--color-primary);
  font-size: var(--font-size-lg);
  font-weight: 700;
}

.contract-value.status-active {
  color: var(--color-success);
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs);
}

.contract-value.status-active::before {
  content: '•';
  font-size: 1.5em;
  line-height: 1;
}

.contract-value.status-active---expanding {
  color: var(--color-success);
}

.contract-value.status-up-for-renewal {
  color: var(--color-warning);
}

.contract-value.status-at-risk---overdue {
  color: var(--color-danger);
  font-weight: 700;
}

.health-score {
  display: inline-flex;
  align-items: center;
  padding: var(--spacing-sm) var(--spacing-lg);
  border-radius: var(--radius-full);
  font-weight: 600;
  margin-top: var(--spacing-sm);
  font-size: var(--font-size-sm);
  letter-spacing: 0.02em;
  transition: all var(--transition-base);
}

.health-score.healthy { 
  background: rgba(16, 185, 129, 0.15);
  color: var(--color-success);
  border: 1px solid rgba(16, 185, 129, 0.3);
}
.health-score.neutral { 
  background: rgba(245, 158, 11, 0.15);
  color: var(--color-warning);
  border: 1px solid rgba(245, 158, 11, 0.3);
}
.health-score.unhealthy { 
  background: rgba(239, 68, 68, 0.15);
  color: var(--color-danger);
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.tickets-section {
  background: var(--surface-card);
  padding: var(--spacing-lg);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  margin-bottom: var(--spacing-lg);
  border: 1px solid var(--surface-border);
  transition: all var(--transition-base);
}

.tickets-section:hover {
  box-shadow: var(--shadow-md);
}

.products-grid {
  display: grid;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.products-grid.single-product {
  grid-template-columns: 1fr;
}

.products-grid.two-products {
  grid-template-columns: 1fr 1fr;
}

@media (max-width: 1200px) {
  .products-grid.two-products {
    grid-template-columns: 1fr;
  }
}

.product-card {
  background: var(--surface-card);
  padding: var(--spacing-lg);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--surface-border);
  transition: all var(--transition-base);
}

.product-card:hover {
  box-shadow: var(--shadow-md);
}

.tickets-section h3 {
  font-size: var(--font-size-lg);
  color: var(--color-secondary);
  margin-bottom: var(--spacing-lg);
  padding-bottom: var(--spacing-sm);
  border-bottom: 2px solid var(--surface-border);
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.summary-section {
  background: var(--surface-card);
  padding: var(--spacing-xl);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--surface-border);
  margin-top: var(--spacing-xl);
}

.summary-section h3 {
  font-size: var(--font-size-xl);
  color: var(--color-secondary);
  margin-bottom: var(--spacing-lg);
  padding-bottom: var(--spacing-md);
  border-bottom: 2px solid var(--color-primary);
  font-weight: 700;
  letter-spacing: -0.02em;
}

.summary-content {
  color: var(--text-secondary);
  line-height: 1.8;
  margin-bottom: var(--spacing-xl);
  font-size: var(--font-size-base);
}`, "",{"version":3,"sources":["webpack://./src/components/AccountDetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oFAAoF;AACtF;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,qCAAqC;EACrC,0BAA0B;EAC1B,+BAA+B;EAC/B,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4CAA4C;EAC5C,iCAAiC;EACjC,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,iCAAiC;EACjC,8CAA8C;EAC9C,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,iCAAiC;EACjC,6CAA6C;EAC7C,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;AAClC","sourcesContent":[".account-detail {\n  display: none;\n  animation: fadeIn var(--transition-slow) ease-out;\n}\n\n.account-detail.active {\n  display: block;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.detail-header {\n  background: var(--surface-card);\n  padding: var(--spacing-xl);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-md);\n  margin-bottom: var(--spacing-xl);\n  border: 1px solid var(--surface-border);\n  position: relative;\n  overflow: hidden;\n}\n\n.detail-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--color-primary), var(--color-primary-light));\n}\n\n.detail-header h2 {\n  font-size: var(--font-size-3xl);\n  color: var(--text-primary);\n  margin-bottom: var(--spacing-sm);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 3rem;\n}\n\n.account-info {\n  flex: 0 0 auto;\n}\n\n.contract-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n  background: var(--color-bg-secondary);\n  padding: var(--spacing-lg);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--surface-border);\n  position: relative;\n}\n\n.contract-info::before {\n  content: 'CONTRACT DETAILS';\n  position: absolute;\n  top: -10px;\n  left: var(--spacing-lg);\n  background: var(--surface-card);\n  padding: 0 var(--spacing-sm);\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n  font-weight: 600;\n  letter-spacing: 0.08em;\n}\n\n.contract-row {\n  display: flex;\n  gap: 2rem;\n}\n\n.contract-item {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.contract-label {\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-weight: 600;\n  margin-bottom: var(--spacing-xs);\n}\n\n.contract-value {\n  font-size: var(--font-size-base);\n  color: var(--color-secondary);\n  font-weight: 600;\n}\n\n.contract-value.highlight {\n  color: var(--color-primary);\n  font-size: var(--font-size-lg);\n  font-weight: 700;\n}\n\n.contract-value.status-active {\n  color: var(--color-success);\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n}\n\n.contract-value.status-active::before {\n  content: '•';\n  font-size: 1.5em;\n  line-height: 1;\n}\n\n.contract-value.status-active---expanding {\n  color: var(--color-success);\n}\n\n.contract-value.status-up-for-renewal {\n  color: var(--color-warning);\n}\n\n.contract-value.status-at-risk---overdue {\n  color: var(--color-danger);\n  font-weight: 700;\n}\n\n.health-score {\n  display: inline-flex;\n  align-items: center;\n  padding: var(--spacing-sm) var(--spacing-lg);\n  border-radius: var(--radius-full);\n  font-weight: 600;\n  margin-top: var(--spacing-sm);\n  font-size: var(--font-size-sm);\n  letter-spacing: 0.02em;\n  transition: all var(--transition-base);\n}\n\n.health-score.healthy { \n  background: rgba(16, 185, 129, 0.15);\n  color: var(--color-success);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n}\n.health-score.neutral { \n  background: rgba(245, 158, 11, 0.15);\n  color: var(--color-warning);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n}\n.health-score.unhealthy { \n  background: rgba(239, 68, 68, 0.15);\n  color: var(--color-danger);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.tickets-section {\n  background: var(--surface-card);\n  padding: var(--spacing-lg);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  margin-bottom: var(--spacing-lg);\n  border: 1px solid var(--surface-border);\n  transition: all var(--transition-base);\n}\n\n.tickets-section:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.products-grid {\n  display: grid;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.products-grid.single-product {\n  grid-template-columns: 1fr;\n}\n\n.products-grid.two-products {\n  grid-template-columns: 1fr 1fr;\n}\n\n@media (max-width: 1200px) {\n  .products-grid.two-products {\n    grid-template-columns: 1fr;\n  }\n}\n\n.product-card {\n  background: var(--surface-card);\n  padding: var(--spacing-lg);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--surface-border);\n  transition: all var(--transition-base);\n}\n\n.product-card:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.tickets-section h3 {\n  font-size: var(--font-size-lg);\n  color: var(--color-secondary);\n  margin-bottom: var(--spacing-lg);\n  padding-bottom: var(--spacing-sm);\n  border-bottom: 2px solid var(--surface-border);\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.summary-section {\n  background: var(--surface-card);\n  padding: var(--spacing-xl);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--surface-border);\n  margin-top: var(--spacing-xl);\n}\n\n.summary-section h3 {\n  font-size: var(--font-size-xl);\n  color: var(--color-secondary);\n  margin-bottom: var(--spacing-lg);\n  padding-bottom: var(--spacing-md);\n  border-bottom: 2px solid var(--color-primary);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.summary-content {\n  color: var(--text-secondary);\n  line-height: 1.8;\n  margin-bottom: var(--spacing-xl);\n  font-size: var(--font-size-base);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
